import PropTypes from 'prop-types';

export const RButtonPropTypes = {
  variant: PropTypes.string,
  fullWidth: PropTypes.bool,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  prependIcon: PropTypes.any,
  type: PropTypes.string,
  variantColor: PropTypes.string,
  height: PropTypes.number,
  form: PropTypes.string,
  children: PropTypes.any,
  onClick: PropTypes.func,
  css: PropTypes.any,
  innerRef: PropTypes.any,
  className: PropTypes.string,
  style: PropTypes.object,
  as: PropTypes.elementType,
};
